<template>
  <v-dialog width="500px" v-model="viewMenu">
    <v-card class="px-7 pb-2">
        <v-card-title class="mx-n7 popup-header">{{title}}</v-card-title>
        <v-layout row wrap v-if="stablast">
            <v-flex xs3>
                <v-subheader v-text="'Lasfall:'"></v-subheader>                  
            </v-flex>
            <v-flex xs9>
                <v-select label="Lastfall" v-bind:items="lastfallliste" item-text="name" :menu-props="{ offsetY: true }" return-object v-model="stablast.Lastfall" required></v-select>
            </v-flex>
            <v-flex xs3>
                <v-subheader v-text="'Stabliste:'"></v-subheader>                  
            </v-flex>
            <v-flex xs9>
               <v-select label="Stabliste" :items="stabliste" item-text="name" :menu-props="{ offsetY: true }" return-object v-model="stablast.Stabliste" small-chips multiple>
                <!-- <template v-slot:selection="props">
                    <span style="font-size: 12px">{{props.item.number + '; '}} </span>
                </template> -->
            </v-select>                       
            </v-flex> 
            <v-flex xs6 row>
                <v-flex xs6>
                    <v-subheader v-text="'Gleichlast:'"></v-subheader>                  
                </v-flex>   
                <v-flex xs6>
                    <v-checkbox v-model="checkGleichlast" class="mt-2"></v-checkbox>
                </v-flex>
                <v-flex xs5 offset-1>
                    <v-text-field label="q1 [kN/m]" type="number" v-model.number="stablast.p1" required></v-text-field>
                </v-flex>
                <v-flex xs5 offset-1 v-if="!checkGleichlast">
                    <v-text-field  label="q2 [kN/m]" type="number" v-model.number="stablast.p2" required></v-text-field>
                </v-flex>
            </v-flex>
            <v-flex xs5 offset-1>
                    <v-radio-group v-model="Lastart">
                        <v-radio v-for="(item, index) in Lastarten" :key="index" :label="item.Label" :value="index"></v-radio>
                    </v-radio-group>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions>
                <v-btn small @click="apply()" color="grey lighten-2" >Übernehmen</v-btn>
                <v-btn small @click="cancel()" color="grey lighten-2" >Abbrechen</v-btn>
                <v-btn small v-if="!$store.getters.newStablast" @click="deleteStablast()"><v-icon dark color="red">remove_circle_outline</v-icon>Löschen</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
import StablastClass from '../../js/Stablast.js'

export default {
    data(){
        return{
            stablast: undefined,
            checkGleichlast: 1,
            Lastarten: [
                {Label: "Global; Stablänge", Orientierung: 0, Bezugslänge: 0},
                {Label: "Global; Projektion", Orientierung: 0, Bezugslänge: 1},
                {Label: "Lokal; Stablänge", Orientierung: 1, Bezugslänge: 0}],
            Lastart: 0,
            LängenEinheit: this.$store.state.LängenEinheiten.m,
            KraftEinheit: this.$store.state.KraftEinheiten.kN
        }
    },
    computed: {
        lastfallliste() { return this.$store.state.StatikSystem ? this.$store.state.StatikSystem.Lastfallliste : [] },
        stabliste() { return this.$store.state.StatikSystem.Stabliste },
        title() { return (this.$store.getters.newStablast || !this.cStablast) ? 'Neue Stablast' : this.cStablast.name +' bearbeiten'},
        viewMenu: {
            get() { return this.$store.getters.vStablastMenu },   
            set(value) { this.$store.commit('setvStablastMenu', value)} 
        },
        cStablast: {
            get() { return this.$store.getters.cStablast },
            }
        },
    methods: {
        apply(){
            if(this.stablast.p1 == 0 && this.stablast.p2 == 0 || !this.stablast.Stabliste.length) return console.log('Es sind keine Werte eingetragen.')
            if(this.checkGleichlast) this.stablast.p2 = this.stablast.p1
            this.stablast.p1 *= this.KraftEinheit.value/this.LängenEinheit.value
            this.stablast.p2 *= this.KraftEinheit.value/this.LängenEinheit.value
            this.stablast.Orientierung = this.Lastarten[this.Lastart].Orientierung
            this.stablast.Bezugslänge = this.Lastarten[this.Lastart].Bezugslänge           
            this.$store.commit('StablastDialogApply', this.stablast)
            this.stablast = undefined
        },
        cancel(){
            this.viewMenu = false
            this.stablast = undefined
        },
        deleteStablast(){
            this.$store.commit('StablastDialogDelete')
        }
    },
    beforeUpdate(){
        if (!this.stablast && this.viewMenu) {
            this.stablast = new StablastClass(this.cStablast.list, 
                                            this.cStablast.p1/this.KraftEinheit.value*this.LängenEinheit.value, 
                                            this.cStablast.p2/this.KraftEinheit.value*this.LängenEinheit.value, 
                                            this.cStablast.Orientierung, 
                                            this.cStablast.Bezugslänge, 
                                            this.cStablast.Stabliste, 
                                            this.cStablast.Lastfall)
            if(this.stablast.Orientierung == 0 && this.stablast.Bezugslänge == 0) this.Lastart = 0
            else if(this.stablast.Orientierung == 0 && this.stablast.Bezugslänge == 1) this.Lastart = 1
            else if(this.stablast.Orientierung == 1 && this.stablast.Bezugslänge == 0) this.Lastart = 2   
            this.checkGleichlast = this.stablast.p1 == this.stablast.p2 ? true : false        
        } 
    },
}
</script>
